import { createContext, useContext } from 'react';

/**
 * AppContext — replaces the module-level _appCtx global bag.
 *
 * All shared state and functions are passed through React Context
 * instead of mutating a global object. This is:
 * - Safer (React controls re-renders)
 * - Debuggable (React DevTools shows context)
 * - Standard React pattern
 *
 * Usage in screens/components:
 *   import { useAppContext } from '../lib/AppContext';
 *   const { batchResults, addToast, userRole } = useAppContext();
 */

export const AppContext = createContext({});

export function useAppContext() {
    return useContext(AppContext);
}
